// Media banner: staggered fade/float-up reveal of the text content (heading,
// subheading, description, button, ...) when the section scrolls into view.
// Optional — gated on the "Enable animation" section setting.
(function () {
  const STAGGER_MS = 120;

  function reveal(root) {
    const items = Array.from(root.children);
    items.forEach((el, i) => {
      el.style.transitionDelay = i * STAGGER_MS + "ms";
    });
    root.classList.add("is-revealed");
  }

  function initSection(section) {
    if (!section || !section.classList.contains("media-banner-section")) return;

    const root = section.querySelector(
      ".media-banner__content[data-media-banner-animate]"
    );
    if (!root) return;

    if (root._mediaBannerObserver) {
      root._mediaBannerObserver.disconnect();
      root._mediaBannerObserver = null;
    }

    root.classList.add("media-banner__content--js");
    root.classList.remove("is-revealed");

    const reduceMotion =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduceMotion) {
      reveal(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          reveal(root);
          observer.disconnect();
          root._mediaBannerObserver = null;
        });
      },
      { threshold: 0.2 }
    );

    observer.observe(root);
    root._mediaBannerObserver = observer;
  }

  initSection(document.currentScript.parentElement);

  if (!window.__themeMediaBannerEvents) {
    window.__themeMediaBannerEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target
        .querySelectorAll(".media-banner__content[data-media-banner-animate]")
        .forEach((root) => {
          if (!root._mediaBannerObserver) return;
          root._mediaBannerObserver.disconnect();
          root._mediaBannerObserver = null;
        });
    });
  }
})();
